// themes/oliveTheme.ts
import {createTheme} from "@mui/material/styles";

export const beOliveTheme = createTheme({
    palette: {
        mode: "light",
        background: {
            default: "#f5f0eb", // be sáng
            paper: "rgba(255, 255, 255, 0.85)",
        },
        primary: {
            main: "#3b6b5a", // xanh rêu đậm
        },
        secondary: {
            main: "#f3a623", // vàng cam accent
        },
        error: {
            main: "#d64541", // đỏ thương hiệu (logo)
        },
        text: {
            primary: "#444444", // xám đậm
            secondary: "#3b6b5a", // xanh phụ
        },
    },

    shape: {
        borderRadius: 12,
    },

    typography: {
        fontFamily: '"Orbitron", sans-serif',
        button: {
            textTransform: "uppercase",
            fontWeight: 700,
            fontSize: "0.9rem",
        },
    },

    components: {
        MuiCssBaseline: {
            styleOverrides: {
                body: {
                    backgroundColor: "rgb(144 8 46 / 60%)",
                    // backgroundImage: `linear-gradient(rgb(228 158 103 / 90%), rgb(175 23 65 / 60%)), url(/assets/archive_bg2.png)`,
                    backgroundImage: `linear-gradient(rgb(228 158 103 / 90%), rgb(144 8 46 / 60%)), url(/assets/archive_bg2.png)`,
                    // backgroundImage: `linear-gradient(rgb(228 158 103 / 56%), rgb(175 23 65 / 46%)), url(/assets/archive_bg2.png)`,
                    backgroundRepeat: "no-repeat",
                    backgroundPosition: "center",
                    backgroundSize: "cover",

                    " & .MuiSideBar": {
                        position: "relative",
                        borderRadius: "12px",
                        backgroundColor: "rgba(59,107,90,0.7)", // xanh rêu overlay
                        padding: "16px",
                        width: "100%",
                        maxWidth: "100%",
                        margin: "0 auto 20px",
                        color: "#fff",
                        " & .titleBox": {
                            display: "flex",
                            justifyContent: "center",
                            backgroundColor: "rgba(255, 255, 255, 0.8)",
                            borderRadius: "8px",
                            padding: "6px 16px",
                            width: "100%",
                            marginBottom: "16px",
                            " & .titleText": {
                                fontWeight: "bold",
                                textTransform: "uppercase",
                                color: "#3b6b5a",
                                letterSpacing: "1px",
                            },
                        },
                    },

                    "& .MuiMessage": {
                        padding: 24,
                        textAlign: "center",
                        borderRadius: "12px",
                        color: "white",
                        fontFamily: '"Orbitron", sans-serif',
                        fontSize: "1.2rem",
                        fontWeight: "bold",
                        letterSpacing: "1px",
                    },

                    "& .CenterButton": {
                        minWidth: "100px",
                        height: "160px",
                        borderRadius: "50%",
                        background: "radial-gradient(circle at 50% 50%, #fffbe6, #f3a623)",
                        border: "2px solid #f3a623",
                        boxShadow: "0 6px 18px rgba(243,166,35,.35)",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        transition: "all 0.25s ease",
                        padding: 0,
                        "&:hover": {
                            transform: "translateY(-2px)",
                            boxShadow: "0 12px 24px rgba(243,166,35,.45)",
                            "& .MuiSvgIcon-root": {
                                color: "#FFD700",
                                filter: "drop-shadow(0 0 8px rgba(255,215,0,0.6))",
                            },
                        },
                        "& .MuiSvgIcon-root": {
                            fontSize: "64px",
                            color: "#b36a00",
                            transition: "all 0.4s ease",
                        },
                    },
                },
            },
        },

        MuiSvgIcon: {
            styleOverrides: {
                root: {
                    "&.muiButtonIcon": {
                        fill: "#976b1b"
                    },
                }
            }
        },

        MuiButton: {
            styleOverrides: {
                root: {
                    borderRadius: 12,
                    fontWeight: "bold",
                    fontFamily: '"Orbitron", sans-serif',
                    backgroundColor: "#cfa789",
                    // backgroundColor: "#eeb890",
                    color: "#832f37",
                    boxShadow: "0 0 6px rgba(0,0,0,0.25)",
                    "&:hover": {
                        backgroundColor: "#95424aa1",
                        color: "#fff",
                        boxShadow: "0 0 12px #95424aa1",
                    },
                    "&:active": {
                        transform: "scale(0.98)",
                    },
                    "&.active": {
                        backgroundColor: "#773b3d", // active giống header xanh rêu
                        color: "white",
                        boxShadow: "0 0 12px #832f37",
                    },
                },
            },
        },


        MuiAppBar: {
            styleOverrides: {
                root: {
                    backgroundColor: "#b464607a", // teal đậm → contrast rõ với nền
                    color: "#FFFFFF",
                }
            }
        },


        MuiOutlinedInput: {
            styleOverrides: {
                root: {
                    backgroundColor: "rgba(255,255,255,0.9)",
                    borderRadius: 12,
                    "& .MuiOutlinedInput-notchedOutline": {
                        borderColor: "transparent",
                    },
                    "&:hover .MuiOutlinedInput-notchedOutline": {
                        borderColor: "#3b6b5a",
                    },
                    "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                        borderColor: "#f3a623",
                        boxShadow: "0 0 6px #f3a623",
                    },
                    input: {
                        color: "#444",
                    },
                },
            },
        },

        MuiPaper: {
            styleOverrides: {
                root: {
                    backgroundColor: "rgba(255,255,255,0.9)",
                    borderRadius: 16,
                    backdropFilter: "blur(6px)",
                    boxShadow: "0 0 6px rgba(0,0,0,0.1)",
                },
            },
        },
    },
});
